import { cn } from '../utils';
import type { LanguageSelectOption } from '../types';
import { useTranslation } from 'react-i18next';

type Props = {
  language: LanguageSelectOption | undefined;
  className?: string;
  iconClassName?: string;
  labelClassName?: string;
};

export const LanguageInfo = ({
  language,
  className,
  iconClassName,
  labelClassName,
}: Props) => {
  const { t } = useTranslation();

  if (!language) {
    return null;
  }

  const { icon, value } = language;

  return (
    <div className={cn('flex items-center gap-[1.6rem]', className)}>
      <img
        className={cn(
          'w-[4.4rem] h-[4.4rem] rounded-full border border-stroke',
          iconClassName
        )}
        src={icon}
        alt={value}
      />
      <h4 className={cn('headline4 text-primary', labelClassName)}>
        {t(`common.language.options.${value}`)}
      </h4>
    </div>
  );
};
